import { getCCTVHealthStatus, getRTDashboardStats, renameGroup } from "../../Api Methods/Api";

const uri = "https://ipio.m2mservices.mobi";

export const ApiEndpoints = {

    // Login
    loginAPI: uri + "/api/v3.0/portal", // Done
    twoFactorAPI: uri + "/api/v3.0/verifyTwoFactor", // Done
    refreshTokenAPI: uri + "/api/v2.0/refreshToken", // Created but not pluged in, in postman returns   "token": "","refreshToken": ""  
    resendOTPAPI: uri + "/api/v2.0/resendOTP",  //  Created but not pluged in , the verification code is 0 and does not work
    resetPortalPasswordAPI: uri + "/api/v2.0/resetPassword", // Done (Login Reset Password Modal) not tested.

    //register app
    registerAppUser: uri + "/api/v1.3/users",

    getDevicesAPI: uri + "/api/v3.0/deviceList/", // Done
    getStatsAPI: uri + "/api/v3.0/stats/",  // Done
    getEventsAPI: uri + "/api/v1.2/events/",  // Getting for the Line Graph in SiteView  - graph needs styling
    getEventsAPI2: uri + "/api/v3.0/portal/device/events/paged/",
    getUsersAPI: uri + "/api/v1.2/deviceAllUsers/", // Getting in SiteView  - table needs update to table used in Dashboard with further styling for particualr cells
    getSingleDeviceAPI: uri + "/api/v4.0/portal/device/", // Done
    getSensorDataAPI: uri + "/api/v2.0/deviceEventList/", // Created but not plugged in, returns : data : [] in postman.
    getActivityLogAPI: uri + "/api/v2.0/portalLogins", //  ready to go.
    getInactiveDevicesAPI: uri + "/api/v2.0/portal/inactiveDevices", // ready to go.
    getCompanyUserListAPI: uri + "/api/v2.0/userList/", // ready to go.
    getUsersDevicesAPI: uri + "/api/v2.0/portal/devices/", //  ready to go.
    checkSiteExists: uri + "/api/v1.0/device/",
    getSiteByUUID: uri + "/api/v1.0/portal/getSiteInfo/", // +siteUUID

    switchLatchAPI: uri + "/socketio/deviceState", // Done
    switchVirtualLatchAPI: uri + "/api/v2.0/virtual/deviceState",  // Done
    switchLatchExternalLinkAPI: uri + "/socketio/virtualDeviceState",  // Done

    switchPulseAPI: uri + "/socketio/pulse",  // Done
    switchVirtualPulseAPI: uri + "/socketio/virtualPulse",  // Done

    setTagAPI: uri + "/api/v1.1/tag/", // Done

    changeRoleAPI: uri + "/api/v2.0/changeRole", // Done
    removeUserAPI: uri + "/api/v1.2/removeUser/",  // Done but not tested. Uncomment it in API to test.
    suspendUserAPI: uri + "/api/v1.0/suspendUserFromSite",

    suspendAPI: uri + "/api/v2.0/suspendDevice/", // Done but no immediate feedback.
    clearLogsAPI: uri + "/api/v1.2/clearLogs/",
    changeOwnerAPI: uri + "/api/v2.0/changeDeviceOwner", // Done
    // copySettingsAPI: uri + "/api/v2.0/portal/copyDeviceSettings", //This will be duplicate site
    copySettingsAPI: uri + "/api/v4.0/portal/copyDeviceConfiguration",
    changeCamectIntegrationAPI: uri + "/socketio/setCamectIntegrationType", // Done
    rebootIPIOAPI: uri + "/socketio/restartIPIO/",
    resetDeviceAPI: uri + "/api/v2.0/portal/factoryReset/",

    copyUsersAPI: uri + "/api/v2.0/duplicateRelationships",
    inviteUserAPI: uri + "/api/v1.2/inviteUser", // Done

    changePortalPassword: uri + "/api/v2.0/changePassword",

    createPortalPasswordAPI: uri + "/api/v1.0/createPortalPassword", // Done not tested.
    createAppAccountAPI: uri + "/api/v1.0/acceptInvite", // create in api, not implemented.

    //Search
    powerSearch: uri + "/api/v4.0/portal/search/",
    userPowerSearch: uri + "/api/v3.0/portal/usersearch",
    pagedDevices: uri + "/api/v3.0/portal/devices/paged",
    activateInstallerModeAPI: uri + "/api/v2.0/installerMode", /* ?  */
    deleteDeviceAPI: uri + "/api/v2.0/deleteDevice/",
    enableUserNotificationsAPI: uri + "/api/v2.0/userNotifications",  //Done

    // Automations


    // HolidayRule
    getHolidaysModes: uri + "/api/v3.0/holidays/", // + {uuid}   //Done
    createHolidayMode: uri + "/api/v3.0/holidays",
    deleteHolidayMode: uri + "/api/v3.0/holidays/",  // + {id}
    editHolidayMode: uri + "/api/v3.0/holidays",

    // Get Rules
    getInputRules: uri + "/socketio/getInputRules/", // + {deviceUUID}
    setInputRule: uri + "/socketio/setInputRule",

    createAdvRule: uri + "/api/v2/rules",
    getAdvRules: uri + "/api/v2/rules/site",    // + /uuid
    deleteAdvRule: uri + "/api/v2/rules",       // +/ruleID
    setAdvRuleEnabled: uri + "/api/v2/rules",   // +/ruleId/toggle
    addActionToAdvRule: uri + "/api/v2/rules",  // +/ruleId/actions
    deleteActionFromAdvRule: uri + "/api/v2/rules/actions",     // +/:actionId

    //Get Schedules
    getSchedules: uri + "/api/v3.0/schedules/", // + {deviceUUID}

    //update Device Details
    updateDeviceDetails: uri + "/api/v1.0/device/", // + {deviceID}
    updateDeviceDetailsExtra: uri + "/api/v2.0/updateDeviceExtras/", // {deviceID}

    //Virtual Sources

    //Generate OTP for lock assigned to pin
    linkLock: uri + "/api/v3.0/igloo/lock/relationship",
    generateLockOTP: uri + "/api/v4.0/igloo/pincode",
    removeLock: uri + "/api/v3.0/igloo/lock/relationship/",  // + {deviceUUID}/{outputPin}

    //camect
    getCamects: uri + "/socketio/getCamectsAndRelationships/", // + {uuid}
    addCamect: uri + "/socketio/addCamect",
    deleteCamect: uri + "/socketio/deleteCamect/", // + {uuid}/{id}
    updateCamect: uri + "/socketio/updateCamect",
    updateCamectRelationship: uri + "/socketio/updateCamectRelationship/",
    getCamectCameras: uri + "/socketio/getCamectCameras/", //+{uuid}/{camectID}

    //Davantis
    getDavantises: uri + "/socketio/getDavantisesAndRelationships/", //+uuid
    addDavantis: uri + "/socketio/addDavantis/",
    updateDavantis: uri + "/socketio/updateDavantis/",
    updateDavantisRelationship: uri + "/socketio/updateDavantisRelationship/",
    deleteDavantis: uri + "/socketio/deleteDavantis/", //+uuid/id

    //SigFox - Sensors
    getVirtualRelationships: uri + "/api/v3.0/virtual/relationships/",  // + {uuid}
    addSigfox: uri + "/api/v2.0/addSigfoxRelationship/",
    unlinkSigfox: uri + "/api/v2.0/virtual/deleteRelationship/", // + {deviceUUID}/{pin}

    sendMessage: "http://localhost:3001/sendMessage",
    performAction: "http://localhost:3001/performAction",

    //Groups
    getGroups: uri + "/api/v4.0/groups", //GET
    addGroup: uri + "/api/v6.0/groups", //POST
    deleteGroup: uri + "/api/v4.0/groups/", //DELETE //+/group ID
    renameGroup: uri + "/api/v4.0/groups/",
    getGroupSites: uri + "/api/v4.0/portal/groups/devices/", //GET //+/groupName
    addSitesToGroup: uri + "/api/v4.0/groups/devices", //POST 
    removeSitesFromGroup: uri + "/api/v4.0/groups/devices/", //DELETE (with body)
    addUserToGroup: uri + "/api/v4.0/groups/users", //POST
    getGroupUsers: uri + "/api/v4.0/groups/users/", //GET //+/groupID
    deleteGroupUser: uri + "/api/v4.0/groups/users/", //DELETE //+/userID
    getGroupStats: uri + "/api/v4.0/groups/stats/",
    editGroupDetails: uri + "/api/v4.0/groups/editGroupDetails",

    //Padlocks
    getPadlocks: uri + "/api/v4.0/portal/iglooLockList", //GET //CHECK TO UPDATE GROUP ONTO THIS API

    //Keyboxes
    getKeyboxes: uri + "/api/v4.0/portal/iglooKeyboxList", //GET

    //Sensors
    getSensors: uri + "/api/v5.0/portal/sensorList",
    getSingleSensor: uri + "/api/v4.0/portal/getSensor/", //+/sensorID
    updateSensor: uri + "/api/v1.0/portal/updateSensor",

    //Users
    getAllUsersPaged: uri + "/api/v4.0/portal/users/allUsersPaged", //POST
    getSingleUser: uri + "/api/v1.0/portal/getSingleUser/", // +UserID

    //getRandomUIPIOID
    getRandomUIPIOID: uri + "/api/v4.0/portal/randomUIPIOID",

    getDashboardStats: uri + "/api/v4.0/portal/dashboardStats",
    getDashboardStatsByGroup: uri + "/api/v4.0/portal/dashboardStatsByGroup",
    getRTDashboardStats: uri + "/api/v4.0/portal/realtimeDashboardStats",
    getRTDashboardStatsByGroup: uri + "/api/v4.0/portal/realtimeDashboardStatsByGroup",

    deleteUserAccount: uri + "/api/v3.0/deleteAccount",

    changePassword: uri + "/api/v2.0/changePassword",

    //Gateway
    linkGateway: uri + "/api/v1.0/gateway/linkGateway",
    unlinkGateway: uri + "/api/v1.0/gateway/unlinkGateway",
    getGateways: uri + "/api/v4.0/portal/gatewaysList",
    getSingleGateway: uri + "/api/v1.0/portal/getSingleGateway", //+/gatewayIMEI
    getEventsForGateway: uri + "/api/v1.0/portal/getEventsForGateway", //+/gatewayIMEI
    updateGateway: uri + "/api/v1.0/portal/updateGateway",

    //ResetPin
    createNewPin: uri + "/api/v1.0/createNewPin",

    //Accept invite to create an app account
    acceptInvite: uri + "/api/v1.0/acceptInvite",

    //Empty sites
    getEmptySites: uri + "/api/v4.0/portal/listEmptySites",
    //Inactive sites
    getInactiveSites: uri + "/api/v4.0/portal/listSitesByStatus",

    //Mass change device name
    updateDeviceName: uri + "/api/v2.0/massChangeDeviceName",

    //Sites on schedule
    getSitesOnSchedule: uri + "/api/v3.0/portal/devicesOnSchedule",

    //Check camect support
    checkSiteConfig: uri + "/api/v1.0/checkSiteConfig",

    //Provision user
    provisionUser: uri + "/api/v1.0/provisionUser",
    createUserPin: uri + "/api/v1.0/createUserPin",

    //Arcs
    listPartneredArcs: uri + "/api/v1.0/arcs/listPartneredArcs",
    setMonitoredBy: uri + "/api/v1.0/arc/setMonitoredBy",

    //Suspend site access for all users
    createSiteAccessRestriction: uri + "/api/v3.0/siteAccessSchedules", //POST
    deleteSiteAccessRestriction: uri + "/api/v3.0/siteAccessSchedules", //:{scheduleID} //DELETE
    getSiteAccessRestrictions: uri + "/api/v3.0/siteAccessSchedules", //:{siteUUID} //GET
    checkAccessRestrictions: uri + "/api/v3.0/siteAccessRestriction", //:{siteUUID}

    //Set site active
    setSiteActive: uri + "/api/v1.0/setSiteActive",

    //Set schedule only
    setScheduleOnly: uri + "/api/v1.0/setScheduleOnly",

    //LiveView
    setSiteLiveView: uri + "/api/v1.0/setSiteLiveView",
    getSitesWithLiveView: uri + "/api/v4.0/portal/listSitesWithLiveView",
    //getLinkedCameras: uri + "/api/v4.0/portal/getCamerasForSite/", //:siteUUID
    getLinkedCameras: uri + "/api/v1.0/videoLiveView/cameras/",

    //Set serial number
    setSerialNumber: uri + "/api/v4.0/portal/setSerial",

    //Get branding for logo in SideNav
    getBrandingName: uri + "/api/v4.0/portal/getGroupBranding",

    //New integrations API for AJAX, Dahua & Hik
    getIntegrations: uri + "/socketio/getIntegrationRelationships",

    //AIBOX
    aiboxLogin: uri + "/api/v2.0/aibox/login/",
    addAibox: uri + "/api/v2.0/aibox/integration",
    removeAibox: uri + "/api/v2.0/aibox/integration",

    //Hikivision
    hikvisionLogin: uri + "/api/v2.0/hikvision/login",
    addHikvision: uri + "/api/v2.0/hikvision/integration",
    unlinkHikivision: uri + "/api/v2.0/hikvision/integration", // /siteUUID/pin

    //Edit user
    editUserDetails: uri + "/api/v4.0/portal/updateUserDetails",

    //Get sites with CCTV integrations
    listSitesWithCCTVIntegration: uri + "/api/v4.0/portal/listSitesWithIntegrations",
    getCCTVHealthStatus: uri + "/api/v4.0/portal/cctvHealthStatus",
    getCCTVHealthStatusByGroup: uri + "/api/v4.0/portal/cctvHealthStatusByGroup/", // /groupID

    getSinglePadlock: uri + "/api/v3.0/igloo/getSingleLock/",
    getLockEvents: uri + "/api/v3.0/igloo/getEventsForLock/",
    updateLockDetails: uri + "/api/v3.0/igloo/lock/updateLockDetails",

    deleteUserAccount: uri + "/api/v4.0/portal/deleteUserAccount",

    getAllSites: uri + "/api/v4.0/portal/listSites",
    getAllSitesNew: uri + "/api/v4.0/portal/listSitesNew",

    //liveView
    addLiveViewCamera: uri + "/api/v1.0/videoLiveView/cameras",
    deleteLiveViewCamera: uri + "/api/v1.0/videoLiveView/cameras/", // +/CameraID
    transferLiveViewCamera: uri + "/api/v1.0/portal/transferCamera",

    //dahua
    dahuaLogin: uri + "/api/v2.0/dahua/login",
    getEventHandlers: uri + "/api/v2.0/dahua/event-handlers",
    addDahua: uri + "/api/v2.0/dahua/integration",
    deleteDahua: uri + "/api/v2.0/dahua/integration/", // /siteUUID/pin

    //AJAX
    ajaxLogin: uri + "/api/v2.0/ajax/login",
    getHubs: uri + "/api/v2.0/ajax/hubs",
    checkHubLinks: uri + "/api/v2.0/ajax/hubs/check-links",
    addAjaxToSite: uri + "/api/v2.0/ajax/addToSite",
    deleteAjax: uri + "/api/v2.0/ajax/", // /siteUUID/HubID

    //Edit Site
    updateSiteDetails: uri + "/api/v4.0/portal/editSite",

    setSiteNotifications: uri + "/api/v1.0/setSiteNotifications",

    setCustomerNumber: uri + "/api/v1.0/portal/setCustomerNumber",

    changePortalGroup: uri + "/api/v1.0/portal/changePortalGroup",
    getAllGroups: uri + "/api/v1.0/portal/getAllGroups",

    // site analytics
    getSiteAnalytics: uri + "/api/v1.0/portal/getAnalytics",

    getUserActivity: uri + "/api/v1.0/portal/getUserActivity",

    //create site
    createSite: uri + "/api/v1.3/devices",

    changePortalRole: uri + "/api/v1.0/portal/changePortalRole",

    getSnapshotCameraList: uri + "/api/v2/rules/snapshot-targets-expanded/site/" // + siteUUID

}

